export default "/fcbcac1db17390110677298f9d30eeed9c121039/b3dc542ec1b5794376b3d1da54a4e35b.svg";